export enum PreAdmissionOrderStatus {
    Active= 1,
    Ordered= 2,
    Canceled= 3
}